import { API, graphqlOperation } from "aws-amplify";

import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import AlertForm from "components/alerts/AlertForm";
import {
  createAlertDevice,
  deleteAlertDevice,
  updateAlert,
} from "graphql/mutations";
import { customGetAlert } from "graphql/custom-queries";
import { Loader } from "@aws-amplify/ui-react";
import { alertDevicesByAlertId } from "graphql/queries";

const AlertUpdateForm = ({ alertId, onSuccess }) => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState();

  async function onSubmit(values) {
    try {
      const {
        name,
        description,
        severity,
        severityColor,
        devices,
        smsNotifications,
        wspNotifications,
        emailNotifications,
        conditions,
        companyID,
        startSchedule,
        endSchedule,
        days,
        execInterval,
        execTime,
        hourInterval,
        executeOnHolidays,
      } = values;
      const promises = [];

      const devicesToUnLink = alert.devices
        ?.filter(
          (alertUs) => !devices?.some((device) => device.id === alertUs.id)
        )
        ?.map((device) => device.id);
      devicesToUnLink?.forEach(async (deviceId) => {
        const alertDeviceRecords = (
          await API.graphql({
            query: alertDevicesByAlertId.replaceAll("__typename", ""),
            variables: {
              alertId,
              filter: {
                and: [{ deviceId: { eq: deviceId } }],
              },
            },
          })
        )?.data?.alertDevicesByAlertId?.items;
        promises.push(
          API.graphql({
            query: deleteAlertDevice.replaceAll("__typename", ""),
            variables: {
              input: {
                id: alertDeviceRecords[0].id,
              },
            },
          })
        );
      });
      const devicesToLink = devices
        ?.filter(
          (device) =>
            !alert.devices?.some((alertDevice) => alertDevice.id === device.id)
        )
        ?.map((device) => device.id);
      devicesToLink?.forEach((deviceId) => {
        promises.push(
          API.graphql({
            query: createAlertDevice.replaceAll("__typename", ""),
            variables: {
              input: {
                alertId,
                deviceId,
              },
            },
          })
        );
      });

      promises.push(
        API.graphql({
          query: updateAlert.replaceAll("__typename", ""),
          variables: {
            input: {
              id: alertId,
              name,
              description,
              severity,
              severityColor,
              smsNotifications,
              wspNotifications,
              emailNotifications,
              conditions: JSON.stringify(conditions),
              companyID,
              startSchedule,
              endSchedule,
              days,
              execInterval,
              execTime,
              hourInterval,
              executeOnHolidays,
            },
          },
        })
      );
      await Promise.all(promises);
      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/alerts");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchAlert(id) {
    try {
      const alertData = await API.graphql(
        graphqlOperation(customGetAlert, { id })
      );
      const alertItem = alertData.data.getAlert;
      if (!alertItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/alerts");
        return;
      }
      const {
        name,
        description,
        devices,
        severity,
        severityColor,
        smsNotifications,
        wspNotifications,
        emailNotifications,
        conditions,
        companyID,
        startSchedule,
        endSchedule,
        days,
        execInterval,
        execTime,
        hourInterval,
        executeOnHolidays,
      } = alertItem;
      setAlert({
        name,
        description,
        devices: devices.items?.map((alertDev) => ({
          id: alertDev.device.id,
          name: alertDev.device.name,
        })),
        severity,
        severityColor,
        smsNotifications,
        wspNotifications,
        emailNotifications,
        conditions: JSON.parse(conditions ?? "[]"),
        companyID,
        startSchedule,
        endSchedule,
        days,
        execInterval,
        execTime,
        hourInterval,
        executeOnHolidays,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchAlert(alertId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertId]);

  if (!alert) return <Loader />;

  return (
    <div>
      <AlertForm onSubmit={onSubmit} type="update" initialValues={alert} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Alerta",
    successUpdated: "Alerta actualizada con éxito",
    responses: {
      errorFetch: "Error al consultar la alerta",
    },
  },
});

export default AlertUpdateForm;
